<template>
  <div class="headerCss">
    <!-- <div class="middle">
        锐单后台管理系统V2.0 <span class=".user-css">{{userName}}</span>
    </div>
    <div class="user-css"></div> -->
    <div class="middle" style="float: left;text-align: center;width:70%;margin-left: 22%;">锐单后台管理系统V2.0</div>
    <div style="float: right;text-align: right;width:30%;">
      <el-popover
        placement="top"
        width="40"
        v-model="visible">
        <!-- <p>是否退出系统?</p> -->
        <div style="text-align: right; margin: 0; width:0px;">
          <el-button size="mini" type="text" @click="logout()">退出系统</el-button>
        </div>
        <el-avatar slot="reference"> {{userName}} </el-avatar>
      </el-popover>
    </div>
  </div>
</template>

<script>

export default {
  data: function() {
    return {
        userName: "",
        visible: false
    };
  },
  mounted() {
    this.userName = this.user.data.userName
    if (this.userName == undefined) {
      this.userName = JSON.parse(window.localStorage.getItem(this.constants.sessions_key)).userName
    }
  },
  methods: {
    logout: function() {
      this.$router.push("/")
    }
  },
};
</script>

<style>
.headerCss {
  height: 60px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-size: 16px;
}
.middle {
  font-weight: 700;
  letter-spacing:2px;
}
.user-css {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue